import React, {useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {currencyConverter} from '../../../utils/commonMethods';

const LiquidityRightBlock = ({eventDetails, eventInfo}) => {
  const rightPanel = [
    {
      title: 'Volume',
      value: eventDetails?.volume
        ? currencyConverter(eventDetails?.volume)
        : '-',
    },
  ];
  const checkForVariable = () => {
    const b = [
      {
        title: 'Liquidity',
        value: eventDetails?.liquidity
          ? currencyConverter(eventDetails?.liquidity)
          : 'N/A',
      },
      {
        title: 'Volatility',
        value: eventDetails?.volatility_factor
          ? `${eventDetails?.volatility_factor}/10`
          : 'N/A',
      },
    ];
    rightPanel.push(b);
  };
  eventInfo?.is_variable_liquidity_pool && checkForVariable();

  return (
    <View style={{alignSelf: 'center', justifyContent: 'space-between'}}>
      {rightPanel.map(item => {
        return (
          <View style={styles.eventRightPanel}>
            <Text
              style={[
                globalFontStyle.appFontSmallText,
                {color: Colors.lightgrey},
              ]}>
              {item.title}
            </Text>
            <Text
              style={[globalFontStyle.appFontSmallText, styles.eventRightText]}>
              {item.value}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

export default LiquidityRightBlock;

const styles = StyleSheet.create({
  eventRightPanel: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  eventRightText: {
    color: Colors.black,
    paddingLeft: 10,
  },
});
